import { ARBITRUM, AVALANCHE, AVALANCHE_FUJI, CUSTOM_DEV_NETWORK } from "config/chains";
import arbitrum from "img/ic_arbitrum_24.svg";
import avalanche from "img/ic_avalanche_24.svg";
import avalancheTestnet from "img/ic_avalanche_testnet_24.svg";

import gmxIcon from "img/ic_gmx_40.svg";
import tmxIcon from "img/ic_tmx_40.svg";
import gmxOutlineIcon from "img/ic_gmxv1flat.svg";
import glpDarkIcon from "img/ic_tlp_40_dark.svg";
import glpIcon from "img/ic_tlp_40.svg";
import esGMXIcon from "img/ic_esgmx_40.svg";
import esGMXArbitrumIcon from "img/ic_esgmx_arbitrum.svg";
import esGMXAvaxIcon from "img/ic_esgmx_avalanche.svg";
import gmIcon from "img/gm_icon.svg";
import gmArbitrum from "img/ic_gm_arbitrum.svg";
import tlpArbitrum from "img/ic_tlp_arbitrum.svg";
import tlpDevnet from "img/ic_tlp_devnet.svg";
import gmAvax from "img/ic_gm_avax.svg";
import gmxArbitrum from "img/ic_gmx_arbitrum.svg";
import tmxArbitrum from "img/ic_tmx_arbitrum.svg";
import gmxAvax from "img/ic_gmx_avax.svg";
import glpArbitrum from "img/ic_glp_arbitrum.svg";
import glpAvax from "img/ic_glp_avalanche.svg";
import glvIcon from "img/ic_glv_40.svg";

type ChainIcons = {
  network?: string;
  gmx: string;
  tmx: string;
  glp: string;
  glp_dark?: string;
  esgmx?: string;
  gm: string;
  tlp: string;
  gmxOutline?: string;
  glv?: string;
};

const ICONS: Record<number | "common", ChainIcons> = {
  [ARBITRUM]: {
    network: arbitrum,
    gmx: gmxArbitrum,
    tmx: tmxIcon,
    glp: glpArbitrum,
    esgmx: esGMXArbitrumIcon,
    gm: gmArbitrum,
    tlp: tlpArbitrum,
    glp_dark: glpDarkIcon,
  },
  [AVALANCHE]: {
    network: avalanche,
    gmx: gmxAvax,
    tmx: tmxIcon,
    glp: glpAvax,
    esgmx: esGMXAvaxIcon,
    gm: gmAvax,
    tlp: tlpArbitrum,
  },
  [AVALANCHE_FUJI]: {
    network: avalancheTestnet,
    gm: gmAvax,
    tlp: tlpArbitrum,
    gmx: gmxAvax,
    tmx: tmxIcon,
    glp: glpAvax,
  },
  [CUSTOM_DEV_NETWORK]: {
    network: avalancheTestnet,
    gm: gmAvax,
    tlp: tlpDevnet,
    gmx: gmxAvax,
    tmx: tmxIcon,
    glp: glpIcon,
    glp_dark: glpDarkIcon,
  },
  common: {
    gmx: gmxIcon,
    tmx: tmxIcon,
    gmxOutline: gmxOutlineIcon,
    glp: glpIcon,
    esgmx: esGMXIcon,
    gm: gmIcon,
    tlp: tlpArbitrum,
    glv: glvIcon,
  },
};

export function getIcon(chainId: number | "common", label: keyof ChainIcons) {
  if (!chainId || !(chainId in ICONS)) {
    throw new Error(`No icons found for chain: ${chainId}`);
  }

  return ICONS[chainId][label];
}
export function getIcons(chainId: number | "common") {
  if (!chainId || !(chainId in ICONS)) {
    throw new Error(`No icons found for chain: ${chainId}`);
  }

  return ICONS[chainId];
}
